module.exports = __webpack_public_path__ + "img/icon-competence-3.446b06ba.svg";